var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading",style:({ height: `${_vm.height}px` })},[_c('div',{staticClass:"loading--layout"},[_c('div',{staticClass:"loading--indicator",style:({ width: _vm.size, height: _vm.size })}),(_vm.text)?_c('div',{staticClass:"loading--explaination",domProps:{"textContent":_vm._s(_vm.text)}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }